/* global RdcTracking */

export const trackSave = function(saveItem, saveAction, listingId='unknown') {
  const props = {
    saveItem,
    saveAction,
    listingId,
  }
  RdcTracking.trackEvent('savedItem', props);
};



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/saves.js